module.exports = __webpack_public_path__ + "media/images/badge/genio_secondary-384dfbfad6fbb082b0f2d2c9fc8f5753.png";